module.exports = __webpack_public_path__ + "img/電気回路_6_4_5.814af786.png";